import { NgModule } from "@angular/core";

import { PrimeNgModule } from "@primeng";
import { CommonModule } from "@angular/common";

import { ReportingCoreModule } from "@main/reporting.v3/reporting-core.module";
import { CssEditorModule } from "@controls/text-editors/css-editor/css-editor.module";
import { HtmlEditorModule } from "@controls/text-editors/html-editor/html-editor.module";
import {
    HtmlRendererComponent
} from "@main/reporting.v3/html-renderer/components/html-renderer.component";
import {
    HtmlEditableRendererComponent
} from "@main/reporting.v3/html-renderer/components/html-editable-renderer.component";

@NgModule({
    declarations: [
        HtmlRendererComponent,
        HtmlEditableRendererComponent,
    ],
    imports: [
        CommonModule,
        PrimeNgModule,

        CssEditorModule,
        HtmlEditorModule,

        ReportingCoreModule,
    ],
    exports: [
        HtmlRendererComponent,
        HtmlEditableRendererComponent,
    ]
})
export class HtmlRendererModule {
}